import React, { Component } from 'react'
import { connect } from 'react-redux'
import values from 'lodash/values'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'

import { FlowPickerSubscriber } from 'apps/flowPicker/components/FlowPickerSubscriber/FlowPickerSubscriber'
import { FlowPickerSource } from 'apps/flowPicker/lib/constants'
import { FlowPickerActions } from 'apps/flowPicker/store'
import * as buttonActions from 'common/builder/actions/buttonActions'
import * as sourceActions from 'common/builder/actions/sourceActions'
import { ButtonType } from 'common/builder/constants/ButtonType'
import { NodeType } from 'common/builder/constants/NodeType'
import NextStepPane from 'common/builder/controllers/builder/NextStepPane'
import { NextStepType } from 'common/builder/models/Source/constants'
import { navigatePollyfill } from 'utils/router/tools'
import { linkURL } from 'utils/url'

class ButtonNextStepPane extends Component {
  static propTypes = {
    type: PropTypes.oneOfType([
      PropTypes.oneOf(values(NextStepType)),
      PropTypes.oneOf(values(ButtonType)),
      PropTypes.oneOf(values(NodeType)),
      PropTypes.oneOf(values(NextStepType)),
    ]),
    builderId: PropTypes.string,
    buttonId: PropTypes.string,
    button: PropTypes.object,
    readonly: PropTypes.bool,
    disableReset: PropTypes.bool,
    onCaptionClick: PropTypes.func,
    target: PropTypes.any,
    keepTarget: PropTypes.bool,
    keepType: PropTypes.bool,
  }

  openFlow = () => {
    navigatePollyfill(linkURL(`/cms/files/${this.props.button.flowId}`))
  }

  openPicker = () => {
    this.props.flowPickerActions.openModal({ source: FlowPickerSource.BUTTON_NEXT_STEP_PANE })
  }

  handleSelectFlow = (flowId) => {
    const { builderId, buttonId } = this.props

    this.props.buttonActions.updateButton(builderId, buttonId, { flowId })
  }

  handleCaptionClick = (e) => {
    if (this.props.type === NextStepType.FLOW) {
      if (this.props.button.flowId) {
        return this.openFlow()
      }
      return this.openPicker()
    }
    this.props.onCaptionClick(e)
  }

  handleReset = () => {
    const { builderId, buttonId, keepType, keepTarget } = this.props

    this.props.buttonActions.resetButtonNextStep(builderId, buttonId, { keepType, keepTarget })
  }

  handleOpen = () => {
    const { builderId, buttonId } = this.props
    return this.props.buttonActions.openButtonNextStep(builderId, buttonId)
  }

  render() {
    const { builderId, type, target, readonly, button, disableReset } = this.props

    return (
      <>
        <NextStepPane
          builderId={builderId}
          source={button}
          type={type}
          readonly={readonly}
          targetId={target && target.id}
          onReset={this.handleReset}
          onOpen={this.handleOpen}
          onCaptionClick={this.handleCaptionClick}
          disableReset={disableReset}
        />
        <FlowPickerSubscriber
          onSelect={this.handleSelectFlow}
          source={FlowPickerSource.BUTTON_NEXT_STEP_PANE}
        />
      </>
    )
  }
}

export default connect(null, (dispatch) => ({
  buttonActions: bindActionCreators(buttonActions, dispatch),
  sourceActions: bindActionCreators(sourceActions, dispatch),
  flowPickerActions: bindActionCreators(FlowPickerActions, dispatch),
}))(ButtonNextStepPane)
